import React from "react";
import InputField, { InputType } from "../../input/inputField";
import { ClassOptionsDropdown } from "../../Classes/ClassOptionsDropdown";
import { GRID_SPACE, GridWrapper } from "../../GridWrapper/GridWrapper";
import { getValue } from "../../../utils/object.utils";

interface Props {
  admissionFee: number | null;
  setAdmissionFee: (admissionFee: number) => unknown;
  annualFee: number | null;
  setAnnualFee: (annualFee: number) => unknown;
  extraClassFee: number | null;
  setExtraClassFee: (extraClassFee: number) => unknown;
  monthlyFee: number | null;
  setMontlyFee: (monthlyFee: number) => unknown;
  examFee: number | null;
  setExamFee: (examFee: number) => unknown;
  stationeryFee: number | null;
  setStationeryFee: (stationeryFee: number) => unknown;
  extraCirculumFee: number | null;
  setExtraCirculumFee: (extraCirculumFee: number) => unknown;
  classId: number | null;
  setClassId: (classId: number | null) => unknown;
}

export const AcademicPricesForm = ({
  admissionFee,
  setAdmissionFee,
  annualFee,
  setAnnualFee,
  extraClassFee,
  setExtraClassFee,
  monthlyFee,
  setMontlyFee,
  examFee,
  setExamFee,
  stationeryFee,
  setStationeryFee,
  extraCirculumFee,
  setExtraCirculumFee,
  classId,
  setClassId,
}: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <GridWrapper
        totalColumns={2}
        gridSpace={GRID_SPACE.sm}
        childrens={[
          {
            component: (
              <ClassOptionsDropdown
                onClassSelect={(selectedClass) => {
                  const classId = getValue(selectedClass, "value");
                  setClassId(classId);
                }}
                selectedClassId={classId}
              />
            ),
            gridSpan: 1,
          },
        ]}
      />

      <GridWrapper
        totalColumns={2}
        childrens={[
          {
            component: (
              <div>
                <InputField
                  value={admissionFee}
                  setValue={setAdmissionFee}
                  label="Admission fee"
                  placeHolder="Enter admission fee"
                  type={InputType.Number}
                />

                <InputField
                  value={annualFee}
                  setValue={setAnnualFee}
                  label="Annual fee"
                  placeHolder="Enter annual fee"
                  type={InputType.Number}
                />
                <InputField
                  value={extraClassFee}
                  setValue={setExtraClassFee}
                  label="Extra class fee"
                  placeHolder="Enter extra class fee"
                  type={InputType.Number}
                />
                <InputField
                  value={monthlyFee}
                  setValue={setMontlyFee}
                  label="Montly fee"
                  placeHolder="Enter montly fee"
                  type={InputType.Number}
                />
              </div>
            ),
            gridSpan: 1,
          },
          {
            component: (
              <div>
                <InputField
                  value={examFee}
                  setValue={setExamFee}
                  label="Exam fee"
                  placeHolder="Enter exam fee"
                  type={InputType.Number}
                />
                <InputField
                  value={stationeryFee}
                  setValue={setStationeryFee}
                  label="Stationary fee"
                  placeHolder="Enter stationary fee"
                  type={InputType.Number}
                />
                <InputField
                  value={extraCirculumFee}
                  setValue={setExtraCirculumFee}
                  label="Extra circulum fee"
                  placeHolder="Enter extra circulum fee"
                  type={InputType.Number}
                />
              </div>
            ),
            gridSpan: 1,
          },
        ]}
        gridSpace={GRID_SPACE.sm}
      />
    </div>
  );
};
